import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Formik, Form } from "formik";

import { fetchCustomerGroupLoanReportService } from "../../../services/reportService";
import { getAllAgentsService } from "../../../services/agentService";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx";

function GroupLoanReport() {
  const [fromDate, setFromDate] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [toDate, setToDate] = useState("");
  const [loans, setLoans] = useState([]);
  const [totalLoans, setTotalLoans] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [agents, setAgents] = useState([]);
  const initialValues = {
    fromDate: null,
    toDate: null,
    frequency: "",
    status: "",
    agent: "",
    search: "",
  };
  const [filters, setFilters] = useState(initialValues);
  const frequencies = ["daily", "weekly", "monthly"];
  const statuses = ["active", "inactive", "closed"];

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //   const handleFilter = () => {
  //     fetchPigmy();
  //     // Fetch or filter customer based on fromDate and toDate
  //   };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const fetchPigmy = async (values) => {
    try {
      const getloans = await fetchCustomerGroupLoanReportService(
        values.fromDate, // Formik values now being used
        values.toDate,
        page,
        rowsPerPage,
        values.frequency,
        values.status,
        values.agent,
        values.search
      );
      setLoans(getloans?.loans);
      setTotalLoans(getloans?.totalLoans);
      setExcelData(getloans?.excelData); // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      excelData.map((loan, index) => ({
        "SL.NO": index + 1,
        "Group Name": loan?.groupLoanId?.groupName,
        "Agent Name": loan.agent?.userName,
        "Customer Name": loan.user?.userName,
        "Phone Number": loan.user?.primaryPhone?.contactValue,
        "Loan Code": loan.loanCode,
        "Loan Amount": loan.loanAmount,
        Frequency: loan.frequency,
        "Loan Tenure": loan.loanTenure,
        "Interest Rate": loan.interest,
        "Disbursed Amount": loan.disbursedAmount,
        "Collection Amount": loan.collectionAmount,
        "Start Date": moment(loan.startDate).format("DD-MM-YYYY"),
        "End Date": moment(loan.endDate).format("DD-MM-YYYY"),
        Status: loan.status,
        "Total Received Amount": loan.totalReceivedAmount,
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");
    XLSX.writeFile(workbook, "LoanReport.xlsx");
  };

  useEffect(() => {
    fetchPigmy(filters);
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchPigmy({});
    fetchAgents();
  }, []);

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Group Loan Report</Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // backgroundColor: "#f7f7ff",
              }}
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  fetchPigmy(values); // Pass Formik values when filtering
                  setFilters(values);
                }}
              >
                {({ values, handleChange, setFieldValue }) => (
                  <Form>
                    <Box sx={{ p: 2 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={2}>
                          <Typography>From Date</Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            size="small"
                            value={values.fromDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true, // This ensures that the label doesn't overlap with the value
                            }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <Typography>To Date</Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            size="small"
                            value={values.toDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Frequency</Typography>
                            <Select
                              name="frequency"
                              value={values.frequency}
                              onChange={handleChange}
                              size="small"
                            >
                              {frequencies.map((freq) => (
                                <MenuItem key={freq} value={freq}>
                                  {freq}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Status</Typography>
                            <Select
                              size="small"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                            >
                              {statuses.map((status) => (
                                <MenuItem key={status} value={status}>
                                  {status}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Agent</Typography>
                            <Select
                              size="small"
                              name="agent"
                              value={values.agent}
                              onChange={handleChange}
                              
                            >
                              {agents.map((agent) => (
                                <MenuItem key={agent._id} value={agent._id}>
                                  {agent.userName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <TextField
                            size="small"
                            label="Search Group Name"
                            fullWidth
                            onChange={(event) => {
                              setFieldValue("search", event.target.value);
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} textAlign="center">
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<i className="fas fa-filter"></i>}
                          >
                            Filter
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={exportToExcel}
                            startIcon={<i className="fas fa-download"></i>}
                            style={{ marginLeft: 10 }}
                          >
                            Download Excel
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>
            <Box sx={{ mt: 2 }}></Box>
            <TableContainer>
              <Table
                sx={{
                  minWidth: 650,
                  borderCollapse: "separate",
                  borderSpacing: "0 8px",
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                    {[
                      "SL.NO",
                      "Group Name",
                      "Agent Name",

                      "Phone Number",
                      "Loan Code",
                      "Loan Amount",
                      "Frequency",
                      "Loan Tenure",
                      "Interest Rate",
                      "Disbursed Amount",
                      "Collection Amount",
                      "Start Date",
                      "End Date",
                      "Status",
                      "Total Received Amount",
                    ].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          color: "#5252ff",
                          padding: "6px",
                          fontWeight: "bold",
                          borderBottom: "1px solid #e0e0e0",
                          textAlign: "center",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loans?.length > 0 ? (
                    loans?.map((row, index) => (
                      <TableRow
                        key={row._id}
                        sx={{
                          backgroundColor:
                            index % 2 === 0 ? "#fafafa" : "#ffffff",
                          borderRadius: "8px",
                          boxShadow: 1,
                        }}
                      >
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.groupName}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.agent?.userName}
                        </TableCell>

                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.groupLeaderPhoneNumber}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.groupCode}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.loanAmount}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.frequency}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.loanTenure}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.interest}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.disbursedAmount}
                        </TableCell>
                        <TableCell>{row?.collectionAmount}</TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {moment(row?.startDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {moment(row?.endDate).format("DD-MM-YYYY")}
                        </TableCell>

                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.status}
                        </TableCell>
                        <TableCell sx={{ padding: "6px", textAlign: "center" }}>
                          {row?.totalReceivedAmount}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        style={{ textAlign: "center", padding: "16px" }}
                      >
                        No pigmys available in table
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalLoans}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Show"
            />
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default GroupLoanReport;
